module.exports = __webpack_public_path__ + "img/landing_pics_md.58a60c69.png";